/*-----------------------------------------------------------------
- Breadcrumbs translations
-----------------------------------------------------------------*/
export default {
    
    slideshows: {
        edit: 'Manage Slides',
    },
    
};
